export interface SEOProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: string;
}

export const defaultSEO: SEOProps = {
  title: 'ProfitIQ.AI - Transform Your Business with AI-Driven Intelligence',
  description: 'Leverage advanced artificial intelligence to optimize your business operations, maximize profitability, and drive sustainable growth with real-time insights and expert guidance. Join 500+ successful businesses achieving an average ROI of 312%.',
  image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=1200&h=630',
  url: 'https://profitiq.ai',
  type: 'website'
};

export const generateSEO = (props: SEOProps = {}): SEOProps => {
  return {
    ...defaultSEO,
    ...props,
  };
};

export const generateStructuredData = (props: SEOProps = {}) => {
  const seo = generateSEO(props);
  
  return {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: 'ProfitIQ.AI',
    description: seo.description,
    url: seo.url,
    image: seo.image,
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Web',
    offers: {
      '@type': 'AggregateOffer',
      priceCurrency: 'USD',
      lowPrice: '299',
      highPrice: '999',
      offerCount: '3',
      availability: 'https://schema.org/InStock',
      priceValidUntil: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString()
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.9',
      reviewCount: '527',
      bestRating: '5',
      worstRating: '1'
    },
    award: [
      'Industry Leader 2024 - Manufacturing Excellence',
      'Healthcare Innovation Award 2024',
      'Best AI Implementation - Business Intelligence',
      'Digital Excellence in Financial Services'
    ],
    review: [
      {
        '@type': 'Review',
        reviewRating: {
          '@type': 'Rating',
          ratingValue: '5',
          bestRating: '5'
        },
        author: {
          '@type': 'Person',
          name: 'Carlos Mendez'
        },
        reviewBody: "ProfitIQ.AI's AI-driven insights helped us identify $127,000 in operational inefficiencies and transform our manufacturing processes.",
        datePublished: '2024-02-15'
      },
      {
        '@type': 'Review',
        reviewRating: {
          '@type': 'Rating',
          ratingValue: '5',
          bestRating: '5'
        },
        author: {
          '@type': 'Person',
          name: 'Dr. Sarah Chen'
        },
        reviewBody: "Their AI analytics revealed critical engagement gaps, helping us improve retention by 32% and boost recurring revenue significantly.",
        datePublished: '2024-02-10'
      }
    ],
    featureList: [
      'AI-Powered Business Intelligence',
      'Real-Time Performance Analytics',
      'Predictive Financial Forecasting',
      'Automated Efficiency Optimization',
      'Strategic Growth Planning',
      'Custom AI Execution Roadmaps',
      'Industry-Specific Insights',
      'ROI-Focused Optimization',
      'Expert Implementation Support',
      'Enterprise-Grade Security'
    ],
    keywords: [
      'AI Business Intelligence',
      'Business Analytics',
      'Financial Optimization',
      'Performance Metrics',
      'Business Growth',
      'AI Analytics',
      'Business Efficiency',
      'Profit Optimization',
      'Strategic Planning',
      'Business Automation',
      'AI Implementation',
      'Business Transformation',
      'Data-Driven Decisions',
      'Enterprise AI',
      'Business ROI'
    ],
    potentialAction: {
      '@type': 'ViewAction',
      target: 'https://profitiq.ai/consultation'
    }
  };
};